import React from 'react';
import { observer } from 'mobx-react';
import Helmet from 'react-helmet';
import TrendsPostView from './TrendsPostView';
import hostname from '../../../../common/env/constants';
import { scrollToTop } from '../../../utils/scrollUtils';
import { formatLandscapeMetaImageUrl } from '../../../utils/imageUtils';

@observer
export default class TrendsPost extends React.Component {
    componentDidMount() {
        scrollToTop();

        const { blogPostUrlPath } = this.props.match.params;
        this.props.actions.trends.loadPostByUrlPath({
            blogPostUrlPath
        });
    }

    render() {
        const store = this.props.rootStore.trends;

        if (store.redirectUrl) {
            const url = store.redirectUrl;
            store.clearRedirectUrl();

            if (window.location) {
                // This will trigger a full re-render and enable
                // the server side rendering to set a 404 response status.
                window.location.href = url;
            }
        }

        const { post } = store;
        const actions = this.props.actions.trends;
        const { summary, title } = post;

        const meta = {
            title: `${title || ''} - Compass`,
            description: summary || '',
            type: 'blog',
            image: formatLandscapeMetaImageUrl(post.imageUrl)
        };

        return (
            <div>
                <Helmet>
                    <title>{meta.title}</title>
                    <meta name="description" content={meta.description} />
                    <meta property="og:title" content={meta.title} />
                    <meta property="og:image" content={meta.image} />
                    <meta property="og:type" content={meta.type} />
                    <meta
                        property="og:description"
                        content={meta.description}
                    />
                </Helmet>
                <TrendsPostView
                    {...this.props}
                    loadPostByUrlPath={actions.loadPostByUrlPath}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/trends/post/index.jsx